import {privacyPolicy} from "../../data/privacyPolicy";
import LegalAccordion from "../../components/LegalAccordion";
import "./PrivacyPolicyPage.css";

const PrivacyPolicyPage = () => {

    return (

        <section className="privacy-page">

            <div className="privacy-hero">

                <span>Legal</span>

                <h1>Privacy Policy</h1>

                <p>

                    We believe trust starts with transparency.
                    This Privacy Policy explains how Magyne
                    collects, uses and protects your information.

                </p>

                <div className="effective-date">

                    Effective Date: July 29, 2026

                </div>

            </div>

            <div className="privacy-container">

                {privacyPolicy.map(section => (

                    <LegalAccordion
                        key={section.id}
                        section={section}
                    />

                ))}

            </div>

        </section>

    );

};

export default PrivacyPolicyPage;